<template>
<!--
    <modal @close="$emit('close')">
        <p class="text-white font-bold text-xl top-font -mt-4" slot="header">Изменение данных</p>

        <div class="pb-5 px-6 text-sm font-semibold text-main-text text-center">

            <p class="text-lg mt-4">Изменения будут внесены в ваши персональные данные</p>
            <div class="flex mx-4 mt-10">
                <button @click="cancel" class="hover-up  mr-3 p-3 text-main-text bg-white border border-additional-text font-semibold">Отменить</button>
                <button @click="accept" class="hover-up p-3 text-white font-semibold font-semibold">Изменить</button>

            </div>


        </div>
    </modal>
-->
<ask-modal-white
                                @white_button="cancel"
                                @yellow_button="accept"
                                whiteButtonText="Отменить"
                                yellowButtonText="Изменить"
                                question = "Изменения будут внесены в ваши персональные данные"
                                ></ask-modal-white>
</template>

<script>
import ModalMixin from '@/mixins/modals';
import Modal from '@/views/modals/base-modal';
import AskModalWhite from '../ask-modal-white';

export default {
  name: 'Participate',
  components: { Modal, AskModalWhite },
  props: ['thanks', 'participate'],
  mixins: [ModalMixin],

  created() {
    this.loaded = true;
  },
  methods: {
    cancel() {
      this.$emit('notAgree');
    },
    accept() {
      this.$emit('agree');
    },
  },
};

</script>

<style scoped>

    button {
        width: 100%;
        border-radius: 28px;
        border: 1px solid rgba(151, 151, 151, 0);
        background-color: #bd006c;
        outline: none;
    }


</style>
